import * as React from 'react'
import type { SVGProps } from 'react'
function SvgKultureinrichtungenStadthalle221982627138(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 223 219.4"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M111.5,0C50,0,0,34,0,75.9v140.5c0,1.7,1.4,3.1,3,3.1h51.5h113.9H220c1.7,0,3-1.4,3-3.1V75.9C223,34,173,0,111.5,0z  M57.6,112.8h107.8v100.5H57.6V112.8z M168.5,106.6H54.5c-1.7,0-3,1.4-3,3.1v103.6H6.1V75.9c0-38.5,47.3-69.8,105.4-69.8 c58.1,0,105.4,31.3,105.4,69.8v137.4h-45.4V109.7C171.5,108,170.1,106.6,168.5,106.6z" />
        <path d="M58.9,81.4H38c-1.7,0-3,1.4-3,3c0,1.7,1.4,3.1,3,3.1h20.8c1.7,0,3-1.4,3-3.1C61.9,82.7,60.6,81.4,58.9,81.4z" />
        <path d="M188,84.4c0-1.7-1.4-3-3-3h-20.8c-1.7,0-3,1.4-3,3c0,1.7,1.4,3.1,3,3.1H185C186.6,87.5,188,86.1,188,84.4z" />
        <path d="M111.5,30.7c-8.6,0-15.6,7-15.6,15.6c0,8.6,7,15.6,15.6,15.6c8.6,0,15.6-7,15.6-15.6C127.1,37.7,120.1,30.7,111.5,30.7z  M111.5,55.9c-5.2,0-9.5-4.3-9.5-9.5c0-5.3,4.3-9.5,9.5-9.5c5.2,0,9.5,4.3,9.5,9.5C121,51.6,116.7,55.9,111.5,55.9z" />
        <path d="M146.8,129.2H76.1c-1.7,0-3,1.4-3,3s1.4,3,3,3h70.7c1.7,0,3.1-1.4,3.1-3S148.5,129.2,146.8,129.2z" />
        <path d="M146.8,149.7H76.1c-1.7,0-3,1.4-3,3s1.4,3,3,3h70.7c1.7,0,3.1-1.4,3.1-3S148.5,149.7,146.8,149.7z" />
        <path d="M146.8,170.2H76.1c-1.7,0-3,1.4-3,3s1.4,3,3,3h70.7c1.7,0,3.1-1.4,3.1-3S148.5,170.2,146.8,170.2z" />
        <path d="M146.8,190.8H76.1c-1.7,0-3,1.4-3,3s1.4,3,3,3h70.7c1.7,0,3.1-1.4,3.1-3S148.5,190.8,146.8,190.8z" />
      </g>
    </svg>
  )
}
export default SvgKultureinrichtungenStadthalle221982627138
